export default __webpack_public_path__ + "static/media/newsletter1.f4c0db46.jpg";